(function (factory) {
	var moduleName = "ccsLogoProgram";

	if (typeof ccs_define === "function") {
		ccs_define(moduleName, ["ccsJq"], factory);
		return;
	}

	var moduleExport = factory(ccsJq);
	if (typeof moduleExport !== "undefined") {
		window[moduleName] = moduleExport;
	}
}
(function ($) {

	var c = {
		addToCartSpanSelector: "span[data-logo-addToCart]",
		eventDataAttr: "data-logo-event",
		eventParamsData: "logo-event-params",
		productVersionAttr: "data-logo-productVersion",
		qtyGlobalVariablePrefix: "cclpQuantity",
		productClickSpanSelector: "span[data-logo-productLink]",
		processedFlag: "ccsLogoProcessed",

		price: {
			elementSelector: "span[data-logo-dynamic-price]",
			getPriceSelector: "a[data-logo-getprice]",
			priceUrlAttr: "data-logo-price-url",
			parsingPriceJsAttr: "data-logo-price-parsingjs",
			runImmediatelyAttr: "data-logo-price-runimmediately",
			errorLogCallAttr: "data-logo-price-error",
			loadingClass: "ccs-logo-price-loading"
		}
	};

	//#region events feature

	function scanEvents(entryId) {
		var entryPrefixSelector = "#" + entryId + " ";

		var addToCartLinkSelector = entryPrefixSelector + c.addToCartSpanSelector + " a";

		if ($(addToCartLinkSelector).length === 0)
			addToCartLinkSelector = entryPrefixSelector + c.addToCartSpanSelector + " form";

		$(addToCartLinkSelector)
			.filter(function () {
				return !$(this).data(c.processedFlag);
			})
			.data(c.processedFlag, true)
			.click(function () {
				var $span = $(this).closest(c.addToCartSpanSelector);
				var productVersion = $span.attr(c.productVersionAttr);
				var eventData = $span.attr(c.eventDataAttr);

				var clientParams = $span.data(c.eventParamsData) || {};
				clientParams.Qty = window[c.qtyGlobalVariablePrefix + productVersion] || 1;

				ccs_cc_log.dispatchEvent(eventData, clientParams, 100);
			});

		var productLinkSelector = entryPrefixSelector + c.productClickSpanSelector + " a";

		$(productLinkSelector)
			.filter(function () {
				return !$(this).data(c.processedFlag);
			})
			.data(c.processedFlag, true)
			.click(function () {
				var $span = $(this).closest(c.productClickSpanSelector);
				var eventData = $span.attr(c.eventDataAttr);
				var clientParams = $span.data(c.eventParamsData) || {};

				ccs_cc_log.dispatchEvent(eventData, clientParams, 100);
			});
	}

	//#endregion

	//#region dynamic price feature

	function scanPriceFeatures(entryId) {
		var $entry = $("#" + entryId);

		$entry
			.find(c.price.elementSelector)
			.filter(function () {
				return !$(this).data(c.processedFlag);
			})
			.data(c.processedFlag, true)
			.each(function () {
				var $priceElement = $(this);

				var priceUrl = $priceElement.attr(c.price.priceUrlAttr);
				var parsingJs = $priceElement.attr(c.price.parsingPriceJsAttr);
				var errorEvent = $priceElement.attr(c.price.errorLogCallAttr);

				var callback = function (e) {
					if (e.error || !e.result) {
						$priceElement.find("." + c.price.loadingClass).hide();
					} else {
						$priceElement.text(e.result);
						$priceElement.trigger("ccs.price-loaded");
					}
				}

				if ($priceElement.attr(c.price.runImmediatelyAttr)) {
					$priceElement.find("." + c.price.loadingClass).show();
					requestPrice(callback, priceUrl, parsingJs, errorEvent);
				} else {
					$priceElement.on("click", c.price.getPriceSelector,
						function () {
							$priceElement.find("." + c.price.loadingClass).show();
							$(this).remove();
							requestPrice(callback, priceUrl, parsingJs, errorEvent);
						});
				}
			});
	}

	/**
	 *
	 * @param {function} callback Will be called with result or error info.
	 * @param {string} priceUrl Product or API url with price information.
	 * @param {string} parsingJs Parsing price JS code.
	 * @param {object} errorEvent (JSON string as appropriate too) eventId of PH-DPRICE event.
	 * @returns {}
	 */
	function requestPrice(callback, priceUrl, parsingJs, errorEvent) {
		if (!callback || !priceUrl || !parsingJs) {
			throw new Error('Can\'t request price: missing function argiments.');
		}

		var errorEventInfo = errorEvent
			? { errorEvent: errorEvent, actionContext: { type: "dynamicPrice", priceUrl: priceUrl } }
			: null;
		
		var ajaxRequest = {
			url: priceUrl,
			dataType: "text", // We expect text response only.
			xhr: function () {
				var xhr = $.ajaxSettings.xhr();
				var setRequestHeader = xhr.setRequestHeader;
				xhr.setRequestHeader = function (name, value) {
					if (name === "X-Requested-With")
						return;

					setRequestHeader.call(this, name, value);
				}
				return xhr;
			},
			success: function (response) {
				grabPriceRecursive(response, callback, parsingJs, errorEventInfo);
			},
			error: function (e, ajaxStatus, httpStatus) {
				if (errorEventInfo && ajaxStatus !== "abort" && ajaxStatus !== "timeout") { //Network problem or page reload are not dynamic pricing problems
					dispatchDynamicPriceEvent(
						errorEventInfo.errorEvent,
						$.extend(
							errorEventInfo.actionContext,
							{
								errorType: "ajax",
								httpCode: e.status, // renamed to ajaxCode TODO: remove httpCode after transition period.
								ajaxCode: e.status,
								ajaxStatus: ajaxStatus,
								httpStatus: httpStatus
							}));
				}

				callback({ error: e });
			}
		};

		if ($.isFunction(window.css_request_price_filter)) {
			window.css_request_price_filter(ajaxRequest);
		}

		$.ajax(ajaxRequest);
	}

	function grabPriceRecursive(response, callback, parsingJs, errorEventInfo) {
		try {
			var json = tryConvert(response, JSON.parse);
			var $html = tryConvert(response, $);

			var parsingPriceFunc = new Function("$", "raw", "$html", "json", parsingJs);
			var result = parsingPriceFunc($, response, $html, json);

			if (result && result.promise) {
				result.done(function (resp) {
					grabPriceRecursive(resp, callback, parsingJs, errorEventInfo);
				});
			} else {
				var resultType = typeof result;
				if (resultType === "number") {
					result = "" + result;
				} else if (resultType !== "string") {
					result = "";
				}

				if (errorEventInfo && $.trim(result) === "") {
					dispatchDynamicPriceEvent(
						errorEventInfo.errorEvent,
						$.extend(
							errorEventInfo.actionContext,
							{
								errorType: "emptyResult"
							}));
				}

				callback({ result: result });
			}
		} catch (e) {
			if (errorEventInfo) {
				dispatchDynamicPriceEvent(
					errorEventInfo.errorEvent,
					$.extend(
						errorEventInfo.actionContext,
						{
							errorType: "parsingException",
							exception: e.name
						}));
			}

			callback({ error: e });
			throw e;
		}
	}

	function tryConvert(response, convertFunc) {
		try {
			return convertFunc($.trim(response));
		} catch (e) {
			return null;
		}
	}

	function dispatchDynamicPriceEvent(eventData, actionContext) {
		var newContext = actionContext;

		var stringValue = ccs_cc_log.getEventParams(eventData)["ActionContext"];
		if (stringValue) {
			var serverContext = JSON.parse(stringValue);
			newContext = $.extend({}, serverContext, actionContext);
		}

		var eventClientParams = { ActionContext: JSON.stringify(newContext) };
		ccs_cc_log.dispatchEvent(eventData, eventClientParams);
	}

	//#endregion

	function detectFeatures(entryId) {
		scanEvents(entryId);
		scanPriceFeatures(entryId);
	}

	window.CcsLogoProgram = {
		detectFeatures: detectFeatures,
		scanEvents: scanEvents,
		requestPrice: requestPrice
	};

	$(document).off("ccs.logo-shown").on("ccs.logo-shown", function (e, eventInfo) {
		var entryId = eventInfo.entryId;
		detectFeatures(entryId);
	});

}));
